import React from 'react';
import Link from 'next/link';

interface IProps {
  links: TLink[];
  mode: 'light' | 'dark';
  mTop?: number;
}

type TLink = {
  title: string;
  href: string;
};

const Breadcrumbs: React.FC<IProps> = ({ links, mode, mTop }) => {
  return (
    <div className={`breadcrumbs breadcrumbs-${mode}`} style={mTop ? { marginTop: mTop } : {}}>
      <Link href="/">Home page</Link> /
      {links.map((item) =>
        !!item.href ? (
          <React.Fragment key={item.title}>
            <Link href={item.href}>{item.title}</Link> /
          </React.Fragment>
        ) : (
          <span className="last-item" key={item.title}>
            {item.title}
          </span>
        )
      )}
    </div>
  );
};

export default Breadcrumbs;
